export const siteContent = {
  brand: {
    name: 'DOTCREATE',
    logoAlt: 'DOTCREATE',
    tagline: 'Strategic. Scalable. Built for Growth.',
    logoSrc: 'https://customer-assets.emergentagent.com/job_dotcreate-lab/artifacts/jwg6kpae_dotcreate%20logo%20-%20icon.png',
  },
  navigation: {
    items: [
      { label: 'Solutions', href: '#solutions' },
      { label: 'Work', href: '#work' },
      { label: 'Process', href: '#process' },
      { label: 'About', href: '#about' },
    ],
    primaryCta: 'Book a Strategy Call',
  },
  contact: {
    email: 'hello@dotcreateph.com',
    phoneDisplay: '+63 953 316 9350',
    phoneLink: '+639533169350',
    socialLinks: [
      { label: 'Instagram', href: 'https://www.instagram.com/dotcreateph' },
      { label: 'Facebook', href: 'https://www.facebook.com/dotcreateph' },
      { label: 'TikTok', href: 'https://www.tiktok.com/@dotcreate?_r=1&_t=ZS-94jrunLtjMK' },
    ],
    businessHours: ['Available Monday - Friday', '9:00 AM - 6:00 PM EST'],
  },
  hero: {
    badge: 'Strategic. Scalable. Built for Growth.',
    headline: ['We Build Digital', 'Systems That Power', 'Serious Growth'],
    subheadline:
      'DOTCREATE helps startups and corporate teams transform ideas into scalable digital platforms, automated operations, and high-impact brand experiences.',
    primaryCta: 'Book a Free Strategy Call',
    secondaryCta: 'View Our Work',
    reassurance: "Tell us what you're building. We'll reply with clear next steps.",
    trustIndicators: [
      { label: 'Custom-Built Solutions', icon: 'zap' },
      { label: 'Business-First Strategy', icon: 'target' },
      { label: 'Scalable Architecture', icon: 'barChart3' },
      { label: 'Long-Term Support', icon: 'shieldCheck' },
    ],
  },
  about: {
    heading: ['Your Growth Is', 'Engineered', 'Not Decorated'],
    intro: 'DOTCREATE is a creative and technology company built for businesses that are ready to scale.',
    features: [
      {
        icon: 'code2',
        title: 'We Build Systems',
        description: 'Not just websites. Complete digital infrastructure that powers modern businesses.',
      },
      {
        icon: 'zap',
        title: 'From Manual to Automated',
        description: 'Transform manual processes into efficient automated workflows.',
      },
      {
        icon: 'trendingUp',
        title: 'Ideas to Revenue',
        description: 'Turn concepts into revenue-generating digital assets.',
      },
      {
        icon: 'shield',
        title: 'Built to Scale',
        description: 'Scalable, secure solutions designed for long-term growth.',
      },
    ],
    missionLead: [
      { text: 'manual to automated', accent: true },
      { text: 'ideas to platforms', accent: true },
      { text: 'concepts to revenue', accent: true },
    ],
    missionBody:
      "Whether you're launching a startup or optimizing corporate operations, we create solutions that work behind the scenes so your business performs at the front.",
  },
  solutions: {
    tech: {
      badge: 'DOTCREATE TECH',
      heading: ['Custom Technology', 'Built for Performance'],
      intro:
        'We develop powerful platforms tailored to your operations, not generic templates. Every system is built with scalability, security, and long-term growth in mind.',
      cta: 'Explore Tech Solutions',
      items: [
        { icon: 'layout', name: 'Learning Management Systems' },
        { icon: 'shoppingCart', name: 'E-Commerce Platforms' },
        { icon: 'users', name: 'MLM Software' },
        { icon: 'barChart3', name: 'POS Systems' },
        { icon: 'calculator', name: 'Accounting Systems' },
        { icon: 'truck', name: 'Delivery Applications' },
        { icon: 'server', name: 'Custom Web Applications' },
        { icon: 'settings', name: 'Admin Dashboards' },
      ],
    },
    creative: {
      badge: 'DOTCREATE 360',
      heading: ['Strategic Design', 'That Drives Action'],
      intro:
        "Design isn't just visual. It's strategic positioning. We craft brand identities and digital experiences that convert attention into trust and trust into business.",
      cta: 'Explore Creative Services',
      items: [
        { icon: 'palette', name: 'Branding & Identity Systems' },
        { icon: 'megaphone', name: 'Marketing & Advertising' },
        { icon: 'share2', name: 'Social Media Creatives' },
        { icon: 'layout', name: 'Website UI/UX Design' },
        { icon: 'pencil', name: 'Ad Campaign Assets' },
        { icon: 'barChart3', name: 'Corporate Presentations' },
      ],
    },
  },
  featuredWork: {
    badge: 'PORTFOLIO',
    heading: ['Real Projects.', 'Real Impact.'],
    intro:
      'Representative work across software, platforms, branding, and digital systems. Every engagement is scoped around business goals, speed, and long-term scalability.',
    proofHighlights: [
      {
        label: 'Built for Scale',
        value: '50,000+ Users',
        note: 'Platform architecture designed for high-volume usage.',
      },
      {
        label: 'Fast Delivery',
        value: '6-Week MVP',
        note: 'Execution speed matched with launch-ready product thinking.',
      },
      {
        label: 'Cross-Functional',
        value: 'Tech + Creative',
        note: 'Systems, branding, UI/UX, and growth assets under one roof.',
      },
    ],
    projects: [
      {
        title: 'Enterprise LMS Platform',
        category: 'EdTech',
        description: 'Scalable learning management system serving 50,000+ users with AI-powered course recommendations.',
        outcome: 'Built to support high-volume learning delivery with long-term scale in mind.',
        proof: '50,000+ user capacity',
        tags: ['React', 'Node.js', 'MongoDB', 'AI Integration'],
      },
      {
        title: 'Multi-Vendor E-Commerce',
        category: 'E-Commerce',
        description: 'Complete marketplace solution with vendor management, payment processing, and analytics dashboard.',
        outcome: 'Centralized vendor operations, payments, and reporting in one platform.',
        proof: 'Marketplace operations streamlined',
        tags: ['Full-Stack', 'Payment Gateway', 'Admin Panel'],
      },
      {
        title: 'Corporate Brand Identity',
        category: 'Branding',
        description: 'Complete brand transformation for B2B SaaS company including visual identity and marketing materials.',
        outcome: 'Sharper positioning across brand, interface, and campaign assets.',
        proof: 'Full visual identity rollout',
        tags: ['Branding', 'UI/UX', 'Marketing'],
      },
      {
        title: 'Logistics Management System',
        category: 'SaaS',
        description: 'Real-time delivery tracking platform with route optimization and automated dispatch.',
        outcome: 'Reduced manual coordination through dispatch and tracking automation.',
        proof: 'Real-time logistics visibility',
        tags: ['Real-Time', 'GPS Integration', 'Automation'],
      },
      {
        title: 'Financial Dashboard',
        category: 'FinTech',
        description: 'Advanced accounting platform with automated reconciliation and financial reporting.',
        outcome: 'Improved reporting accuracy and visibility for finance operations.',
        proof: 'Automated reconciliation workflows',
        tags: ['Accounting', 'Analytics', 'Security'],
      },
      {
        title: 'Startup MVP Launch',
        category: 'Startup',
        description: 'Investor-ready platform built in 6 weeks, successfully raised seed funding.',
        outcome: 'Fast execution without sacrificing the foundation needed for growth.',
        proof: 'Launched in 6 weeks',
        tags: ['MVP', 'Fast Execution', 'Scalable'],
      },
    ],
    linkLabel: 'See Project Snapshot',
    closingLabel: 'Trust Starts With Clarity',
    closingText:
      'No inflated promises. No recycled templates. We focus on fit, execution, and systems that actually support business growth after launch.',
  },
  whyDotCreate: {
    badge: 'WHY DOTCREATE',
    heading: ['Why Businesses Choose', 'DOTCREATE'],
    intro:
      'We combine strategy, systems, design, and execution so businesses can move with more clarity, more structure, and less wasted momentum.',
    reasons: [
      {
        icon: 'brain',
        title: 'Business Strategy Before Build',
        description:
          'We do not jump straight into visuals or code. We start with business goals, operational needs, and the outcome the project needs to drive.',
      },
      {
        icon: 'trendingUp',
        title: 'Built Around Growth Systems',
        description:
          'We design platforms, workflows, and digital assets that support revenue, efficiency, and scale instead of adding more complexity.',
      },
      {
        icon: 'rocket',
        title: 'Custom Execution, Not Recycled Templates',
        description:
          'DOTCREATE builds around your business model, process, and priorities. No one-size-fits-all delivery and no generic agency shortcuts.',
      },
      {
        icon: 'users2',
        title: 'Startup Speed With Corporate Discipline',
        description:
          'We know when to move fast, when to document properly, and how to build for teams that need both agility and structure.',
      },
      {
        icon: 'shield',
        title: 'Tech and Creative in One Direction',
        description:
          'We connect systems, UI/UX, branding, and marketing assets so the business feels aligned from backend operations to customer experience.',
      },
      {
        icon: 'headphones',
        title: 'Long-Term Partner Mindset',
        description:
          'We care about what happens after launch too. That means refinement, support, optimization, and helping the business keep moving forward.',
      },
    ],
    positioningLabel: 'Our Positioning',
    positioningLead: 'Not just an agency that makes things look good.',
    positioningAccent: 'A partner that helps the business work better.',
  },
  process: {
    heading: ['From Strategy to Launch', 'Structured for Success'],
    intro: 'No guesswork. No shortcuts. Just structured execution.',
    steps: [
      {
        icon: 'search',
        iconAnimation: 'process-icon-search',
        number: '01',
        title: 'Discovery & Strategy',
        description: 'We analyze your business model, operations, and growth goals.',
      },
      {
        icon: 'layers',
        iconAnimation: 'process-icon-layers',
        number: '02',
        title: 'Planning & Architecture',
        description: 'We map your system, user flow, and digital infrastructure.',
      },
      {
        icon: 'code',
        iconAnimation: 'process-icon-code',
        number: '03',
        title: 'Design & Development',
        description: 'We build with precision - function first, then refinement.',
      },
      {
        icon: 'testTube',
        iconAnimation: 'process-icon-test',
        number: '04',
        title: 'Testing & Optimization',
        description: 'We ensure performance, speed, and reliability.',
      },
      {
        icon: 'rocket',
        iconAnimation: 'process-icon-rocket',
        number: '05',
        title: 'Launch & Support',
        description: 'We deploy, monitor, and continuously improve.',
      },
    ],
  },
  targetAudience: {
    startup: {
      icon: 'rocket',
      heading: 'For Startups',
      subheading: 'Build It Right the First Time',
      intro: 'Your MVP needs more than design. It needs structure.',
      bullets: [
        'Build scalable platforms',
        'Develop monetization-ready systems',
        'Automate backend operations',
        'Create investor-ready digital products',
      ],
      closingLead: 'Start strong.',
      closingAccent: 'Scale confidently.',
      cta: 'Book a Startup Strategy Call',
    },
    corporate: {
      icon: 'building2',
      heading: 'For Corporate Teams',
      subheading: 'Modernize Operations. Increase Efficiency.',
      intro: 'Corporate teams partner with DOTCREATE to optimize and scale.',
      bullets: [
        'Digitize internal processes',
        'Automate reporting and workflows',
        'Build secure internal systems',
        'Upgrade outdated platforms',
        'Improve digital customer experience',
      ],
      closingLead: 'Efficiency is',
      closingAccent: 'profitability.',
      cta: 'Book an Operations Strategy Call',
    },
  },
  contactSection: {
    heading: ['Book a Free', 'Strategy Call'],
    intro:
      "Tell us what you're building and we'll reply with clear next steps, practical direction, and the best way to move your project forward.",
    reassuranceTags: ['Free initial consult', 'Clear next steps', 'No hard sell'],
    projectTypes: [
      { value: 'custom-software', label: 'Custom Software Development' },
      { value: 'ecommerce', label: 'E-Commerce Platform' },
      { value: 'lms', label: 'Learning Management System' },
      { value: 'branding', label: 'Branding & Design' },
      { value: 'mvp', label: 'Startup MVP' },
      { value: 'corporate', label: 'Corporate Solution' },
      { value: 'other', label: 'Other' },
    ],
    timelineOptions: [
      'As soon as possible',
      'Within 30 days',
      'Within 60 days',
      'Within 90 days',
      'Still exploring',
    ],
    budgetOptions: [
      'Below PHP 100K',
      'PHP 100K - 300K',
      'PHP 300K - 700K',
      'PHP 700K+',
      'Need guidance first',
    ],
    submitLabel: 'Request a Strategy Call',
    submittingLabel: 'Preparing...',
    directContactLabel: 'Or reach us directly:',
    nextStepsTitle: 'What Happens Next',
    nextSteps: [
      {
        step: '01',
        title: 'We review your brief',
        description: 'We look at your goals, scope, and timeline so the response is actually relevant.',
      },
      {
        step: '02',
        title: 'We reply with direction',
        description: 'You get a practical recommendation on the best next move for your project.',
      },
      {
        step: '03',
        title: 'We align on execution',
        description: 'If it is a fit, we talk through scope, priorities, and how to move forward.',
      },
    ],
    responseExpectationTitle: 'Response expectation',
    responseExpectationText:
      'Your email app opens with the project brief already filled in so you can send it right away.',
  },
  footer: {
    solutionsLinks: ['Tech Solutions', 'Creative Services', 'Custom Development', 'Branding & Design'],
    companyLinks: [
      { label: 'About Us', href: '#about' },
      { label: 'Our Work', href: '#work' },
      { label: 'Our Process', href: '#process' },
      { label: 'Contact', href: '#contact' },
    ],
    legalLinks: ['Privacy Policy', 'Terms of Service'],
    copyrightPrefix: '(c)',
  },
};
